import SportCode from "components/common/SportCode";
import React from "react";

export function ScoreContainer(props) {
  const { resultObj } = props;
  const result = resultObj?.result ? resultObj?.result : ''
  const resCode = resultObj?.extra?.resCode ? resultObj?.extra?.resCode : ''
  const resRound = resultObj?.extra?.resRound ? resultObj?.extra?.resRound : ''
  return (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center'>
      <div className='fw-bold p-0 text-end '>
        <SportCode code={resCode} entity="@ResultCode" abbr={true} /> <SportCode code={resRound} entity="@Period" abbr={true} /> {result}
      </div>
    </div>
  )
}